// Re-export the existing CompanyManagement component for Settings/Company
import { CompanyManagement } from './company/CompanyManagement'

interface SettingsCompanyProps {
  onNavigateHome?: () => void
  companyId?: string
}

export function SettingsCompany({ onNavigateHome }: SettingsCompanyProps) {
  return <CompanyManagement onNavigateHome={onNavigateHome} />
}
